import { render, staticRenderFns } from "./TestSettingsList.vue?vue&type=template&id=be364f32"
import script from "./TestSettingsList.vue?vue&type=script&lang=js"
export * from "./TestSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports